import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BadgesAsPartButtons, Messages } from "../../../../Constant";
import { Mail } from "react-feather";
import { BADGE_BUTTON_DATA } from "../../../../Data/UiKit/BadgesContextualVariations";
import { Btn } from "../../../../AbstractElements";
import { DynamicBadgesAsPartButtons } from "./DynamicBadgesAsPartButtons";

const BadgesAsPartButtonsCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={BadgesAsPartButtons} span={BADGE_BUTTON_DATA} />
        <CardBody>
          <div className="badge-spacing flex-column align-items-start">
            <Btn color="primary" className="d-flex align-items-center" type="button">{Messages}
            <span className="badge rounded-circle btn-p-space badge-light text-dark ms-2"><Mail /></span>
            </Btn>
            <DynamicBadgesAsPartButtons/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BadgesAsPartButtonsCart;
